module.exports = __webpack_public_path__ + "static/media/holmes-2.bd3f318b.jpg";